export const GENDER_OPTIONS = [
  { value: "Woman", label: "Woman" },
  { value: "Man", label: "Man" },
  { value: "Nonbinary", label: "Nonbinary" },
  { value: "Genderqueer", label: "Genderqueer" },
  { value: "Transgender Woman", label: "Transgender Woman" },
  { value: "Transgender Man", label: "Transgender Man" },
  { value: "Prefer not to say", label: "Prefer not to say" },
  { value: "Other", label: "Other" },
];
